// extracted by mini-css-extract-plugin
export default {"masonry":"masonry___1TdLA","item":"item___L3fvF","isSpanningTwoColumns":"isSpanningTwoColumns___2De6f","msg":"msg___yQyPm"};